<sc-file-button class="w-100 h-100" (filesChanged)="upload($event)">
    <img [src]="image" alt="Bild" class="img-fluid" *ngIf="image" />
    <div *ngIf="!image" class="btn btn-sm btn-outline-primary">Auswählen</div>
</sc-file-button>